<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Payment Webhook Logs</h4>
        <div class="text-muted small">Inspect provider webhook attempts and processing status</div>
      </div>

      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="loadLogs()">
        Refresh
      </button>
    </div>

    <div class="card border-0 shadow-sm mb-3">
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-3">
            <label class="form-label">Provider</label>
            <select class="form-select" [(ngModel)]="providerCode" [ngModelOptions]="{ standalone: true }">
              <option value="">All</option>
              <option value="BLAAIZ">Blaaiz</option>
              <option value="FLUTTERWAVE">Flutterwave</option>
              <option value="PAYSTACK">Paystack</option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label">Status</label>
            <select class="form-select" [(ngModel)]="processingStatus" [ngModelOptions]="{ standalone: true }">
              <option value="">All</option>
              <option value="Received">Received</option>
              <option value="Processed">Processed</option>
              <option value="Failed">Failed</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label">Search</label>
            <input class="form-control" [(ngModel)]="search" [ngModelOptions]="{ standalone: true }"
              placeholder="Reference, event, hash..." />
          </div>

          <div class="col-md-2 d-flex gap-2">
            <button class="btn btn-primary w-100" type="button" (click)="page = 1; loadLogs()">
              Apply
            </button>

            <button class="btn btn-outline-secondary" type="button" (click)="resetFilters()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card border-0 shadow-sm">
      <div class="card-body">
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm me-2"></div>
          Loading webhook logs...
        </div>

        <div class="table-responsive" *ngIf="!loading">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Provider</th>
                <th>Event</th>
                <th>Status</th>
                <th>Gateway Ref</th>
                <th>External Ref</th>
                <th>Created</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of items">
                <td class="fw-semibold">{{ item.providerCode }}</td>
                <td>{{ item.eventType || '-' }}</td>
                <td>
                  <span [class]="getStatusClass(item.processingStatus)">
                    {{ item.processingStatus }}
                  </span>
                </td>
                <td>
                  <code>{{ item.gatewayReference || '-' }}</code>
                </td>
                <td>
                  <code>{{ item.externalReference || '-' }}</code>
                </td>
                <td>{{ item.createdAt | date:'medium' }}</td>
                <td class="text-end">
                  <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-outline-primary btn-sm" type="button" (click)="openDetails(item)">
                      View
                    </button>

                    <button class="btn btn-success btn-sm" type="button" *ngIf="canResolveBlaaizCadWebhook(item)"
                      (click)="openResolveModal(item)">
                      Resolve Deposit
                    </button>
                  </div>
                </td>
              </tr>

              <tr *ngIf="!items.length">
                <td colspan="7" class="text-center text-muted py-4">
                  No webhook logs found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="!loading">
          <div class="small text-muted">
            Page {{ page }} of {{ totalPages }} — {{ totalItems }} total
          </div>

          <div class="d-flex gap-2">
            <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="page <= 1"
              (click)="previousPage()">
              Previous
            </button>

            <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="page >= totalPages"
              (click)="nextPage()">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

<div class="modal fade show" tabindex="-1" [ngStyle]="{ display: showDetailsModal ? 'block' : 'none' }"
  [class.d-block]="showDetailsModal" *ngIf="showDetailsModal">

  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <h5 class="modal-title">Webhook Details</h5>
        <button type="button" class="btn-close" (click)="closeDetails()"></button>
      </div>

      <div class="modal-body">
        <div *ngIf="detailLoading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm me-2"></div>
          Loading details...
        </div>

        <ng-container *ngIf="!detailLoading && selected">
          <div class="row g-3 mb-3">
            <div class="col-md-3">
              <div class="text-muted small">Provider</div>
              <div class="fw-semibold">{{ selected.providerCode }}</div>
            </div>

            <div class="col-md-3">
              <div class="text-muted small">Event</div>
              <div class="fw-semibold">{{ selected.eventType || '-' }}</div>
            </div>

            <div class="col-md-3">
              <div class="text-muted small">Status</div>
              <span [class]="getStatusClass(selected.processingStatus)">
                {{ selected.processingStatus }}
              </span>
            </div>

            <div class="col-md-3">
              <div class="text-muted small">Created</div>
              <div class="fw-semibold">{{ selected.createdAt | date:'medium' }}</div>
            </div>

            <div class="col-md-6">
              <div class="text-muted small">Gateway Reference</div>
              <code>{{ selected.gatewayReference || '-' }}</code>
            </div>

            <div class="col-md-6">
              <div class="text-muted small">External Reference</div>
              <code>{{ selected.externalReference || '-' }}</code>
            </div>

            <div class="col-md-12" *ngIf="selected.errorMessage">
              <div class="alert alert-danger">
                {{ selected.errorMessage }}
              </div>
            </div>
          </div>

          <label class="form-label fw-semibold">Payload</label>
          <pre class="bg-dark text-light rounded p-3 small webhook-payload">{{ formatJson(selected.payloadJson) }}</pre>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade show"
  tabindex="-1"
  [ngStyle]="{ display: showResolveModal ? 'block' : 'none' }"
  [class.d-block]="showResolveModal"
  *ngIf="showResolveModal">

  <div class="modal-dialog modal-lg">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <h5 class="modal-title">Resolve CAD Deposit</h5>
        <button type="button" class="btn-close" (click)="closeResolveModal()"></button>
      </div>

      <div class="modal-body">
        <div class="alert alert-warning">
          This webhook came from an Interac sender email that was not registered at the time it arrived.
          Select the correct user only after manual verification.
        </div>

        <div class="mb-3" *ngIf="selectedResolveLog">
          <div class="small text-muted">Gateway Reference</div>
          <code>{{ selectedResolveLog.gatewayReference || '-' }}</code>
        </div>

        <div class="mb-3">
          <label class="form-label">Search User</label>
          <input
            class="form-control"
            [(ngModel)]="resolveUserSearch"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Search by name, email, or user id">
        </div>

        <div class="mb-3">
          <label class="form-label">Select User</label>

          <div *ngIf="usersLoading" class="text-muted small">
            Loading users...
          </div>

          <select
            class="form-select"
            [(ngModel)]="resolveUserId"
            [ngModelOptions]="{ standalone: true }"
            *ngIf="!usersLoading">
            <option value="">Select user</option>

            <option *ngFor="let user of filteredUsers" [value]="user.id">
              {{ user.firstName }} {{ user.lastName }} — {{ user.email }}
            </option>
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label">Admin Note</label>
          <textarea
            class="form-control"
            rows="3"
            [(ngModel)]="resolveNote"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Example: Confirmed sender email belongs to selected user."></textarea>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-outline-secondary"
          type="button"
          [disabled]="resolving"
          (click)="closeResolveModal()">
          Cancel
        </button>

        <button
          class="btn btn-success"
          type="button"
          [disabled]="resolving || !resolveUserId"
          (click)="resolveWebhook()">
          <span *ngIf="!resolving">Resolve & Credit Deposit</span>
          <span *ngIf="resolving" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade show" *ngIf="showResolveModal"></div>
<div class="modal-backdrop fade show" *ngIf="showDetailsModal"></div>